import React from 'react'
import Header from '../Components/Header/Header'
import Header2 from '../Components/Header2/Header2'

import Contantsection1 from '../Components/Contantsection/Contantsection1'
import Contantsection2 from '../Components/Contantsection/Contantsection2'

import CenteredText from '../Components/CenteredText/CenteredText'
import FaqContainer from '../Components/FaqContainer/FaqContainer'
import Footer from '../Components/Footer/Footer'
import Homeblock from '../Components/SectionBlock/Homeblock' 
import Categories from '../Components/Categories/Categories'
import FeaturedProducts from '../Components/FeaturedProducts/FeaturedProducts'
import ResourcesSection from '../Components/ResourcesSection/ResourcesSection'
import AboutSection from '../Components/AboutSection/AboutSection'
import PromiseSection from '../Components/PromiseSection/PromiseSection'
import ContactForm from '../Components/ContactForm/ContactForm'
import PowderSlider from '../Components/PowderSlider/PowderSlider'

const Home = () => {
  return (
    <div>
      {/* <Header/> */}
      {/* <Header2/> */}
       <Homeblock />  
       <Categories />
       <FeaturedProducts/>
       <ResourcesSection/>
       <PowderSlider/>
       <AboutSection/>
       <PromiseSection/>
       <ContactForm/>

      
      {/* <Contantsection1/>
      <Contantsection2/>
      <CenteredText/> */}
      
      
      {/* <FaqContainer/> */}
      <Footer/>
      
      

    </div>
  )
}

export default Home
